<template>
  <div>
    <v-dialog v-model="open" max-width="600px" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="info"
            text
            small
            v-bind="attrs"
            v-on="on"
        >
          Classificar
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          Classificar avaliação
        </v-card-title>

        <v-card-text>
          <div class="d-flex">
            <v-avatar
                class="mr-4"
                color="primary"
                size="48"
            >
              <img
                  v-if="review.reviewer_photo_url"
                  :src="review.reviewer_photo_url"
                  :alt="review.reviewer_name"
              >
              <span v-else class="white--text body-1 font-weight-medium">{{ getInitials(review.reviewer_name) }}</span>
            </v-avatar>

            <div>
              <v-row
                  align="center"
                  class="mx-0 mb-0"
              >
                <v-rating
                    :value="5"
                    color="amber"
                    dense
                    half-increments
                    readonly
                    size="14"
                ></v-rating>
              </v-row>

              <div class="subtitle-2 text--primary">
                {{ review.reviewer_name }}
              </div>

              <div>{{ review.comment }}</div>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4"></v-divider>

        <v-card-text class="mt-3">
          <v-chip-group
              active-class="deep-purple accent-4 white--text"
              column
              v-model="formData.feeling"
          >
            <v-chip value="POSITIVE">Positivo</v-chip>

            <v-chip value="NEGATIVE">Negativo</v-chip>

            <v-chip value="NEUTRAL">Neutro</v-chip>
          </v-chip-group>
        </v-card-text>

        <v-card-text>
          <v-form
              ref="form"
              v-model="formValid"
              lazy-validation
          >
            <v-autocomplete
                chips
                autocomplete="off"
                multiple
                v-model="formData.keywords"
                :search-input.sync="searchKeyword"
                :loading="loadingKeywords"
                :items="keywords.data"
                item-text="name"
                item-value="id"
                menu-props="auto"
                label="Tags"
                outlined
                clearable
            ></v-autocomplete>
          </v-form>

          <v-btn
              color="secondary"
              text
              small
              @click="openKeywordModal"
          >
            Criar tag
          </v-btn>

          <keyword-detail-modal
              :open="openModalKeyword"
              title="Criar tag"
              :data="{ account_id: review.account.id }"
              action-type="CREATE"
              :on-close="closeKeywordModal"
              :on-save="onSaveKeyword"
              :on-delete="() => {}"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="secondary"
              text
              @click="cancel"
          >
            Cancelar
          </v-btn>
          <v-btn
              :loading="loading"
              color="primary"
              text
              @click="updateReview"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {handleResponseError} from '@/api/handleError'
import _ from 'lodash'
import KeywordDetailModal from '@/views/Keywords/KeywordDetailModal'

export default {
  name: "LocationCodeModal",
  props: {
    review: {
      type: Object,
      required: true
    },
    onSuccess: Function,
    onError: Function,
  },
  computed: {
    ...mapState({
      location: state => state.locations.location,
      keywords: state => state.keywords.all,
    }),
    _() {
      return _
    },
  },
  components: {
    KeywordDetailModal
  },
  methods: {
    cancel: function() {
      this.open = false
      this.resetData()
    },
    updateReview: async function () {
      if (!this.validate()) return
      this.loading = true
      await this.$store.dispatch('reviews/update', { id: this.review.id, data: this.formData })
          .then(() => {
            if (this.onSuccess) this.onSuccess()
            this.open = false
          })
          .catch(e => {
            if (this.onError) this.onError()
            const message = handleResponseError(e, 'Ocorreu um erro ao atualizar a avaliação.')
            this.showNotification(message, 'red darken-2')
            this.loading = false
          })
      this.loading = false
    },
    showNotification: function(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    validate: function() {
      return this.$refs.form.validate()
    },
    resetData: function() {
      const {store_code} = this.formDataOriginal
      this.formData.store_code = store_code
    },
    fetchKeywords: async function () {
      if (!this.review.account) return
      this.loadingKeywords = true
      await this.$store.dispatch('keywords/getKeywords', {
        account: _.get(this.review, 'account.name'),
        search: this.searchKeyword,
        limit: 100,
        page: 1,
        order: 'asc',
        sort: 'name',
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as tags.')
        this.showNotification(message, 'red darken-2')
        this.loadingKeywords = false
      })
      this.loadingKeywords = false
    },
    getInitials: function (name) {
      return (name || '').toString().split(' ').map(l => l.charAt(0)).slice(0, 2).join('')
    },
    openKeywordModal: function () {
      this.openModalKeyword = true
    },
    closeKeywordModal: function () {
      this.openModalKeyword = false
    },
    onSaveKeyword: function() {
      this.closeKeywordModal()
      this.fetchKeywords()
    }
  },
  data: () => ({
    timeoutKeywords: null,
    loadingKeywords: false,
    searchKeyword: '',
    open: false,
    openModalKeyword: false,
    loading: false,
    formValid: true,
    formDataOriginal: {},
    formData: {
      keywords: [],
      feeling: null
    },
    codeRules: [
      v => !!v || 'O código da empresa é obrigatório',
    ],
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    }
  }),
  created() {
    this.formData.feeling = this.review.feeling
    this.formData.keywords = Array.isArray(this.review.keywords) && this.review.keywords.map(k => k.id)
  },
  beforeDestroy() {
    this.resetData()
  },
  watch: {
    searchKeyword: function() {
      clearTimeout(this.timeoutKeywords)
      this.timeoutKeywords = setTimeout(this.fetchKeywords, 300)
    },
    review: function (review) {
      this.formData.feeling = review.feeling
      this.formData.keywords = Array.isArray(review.keywords) && review.keywords.map(k => k.id)
    }
  }
}
</script>

<style scoped>

</style>